/**
 * Genera la sequenza "custom bottom-up" per staffetta: solo accoppiamenti (i,i) partendo dal basso.
 * Esempio: membriA [1,2,3,4], membriB [a,b,c,d] => [1-a, 3-c, 2-b, 4-d]
 *
 * @param {Array} membriA - Array di membri squadra A (oggetti con almeno .name)
 * @param {Array} membriB - Array di membri squadra B (oggetti con almeno .name)
 * @param {string} squadraA - Nome squadra A
 * @param {string} squadraB - Nome squadra B
 * @param {string} categoria - Nome categoria
 * @param {number} stoccate - Stoccate per assalto
 * @returns {Array} Array di assalti custom bottom-up
 */
export function generateAssaltiCustomBottomUp(membriA, membriB, squadraA, squadraB, categoria, stoccate) {
  // Controllo nomi squadra
  const nomeA = squadraA && typeof squadraA === 'string' ? squadraA : (squadraA?.name || 'Squadra A');
  const nomeB = squadraB && typeof squadraB === 'string' ? squadraB : (squadraB?.name || 'Squadra B');

  if (membriA.length === 4 && membriB.length === 4) {
    const pattern = [
      [0,0], // 1-a
      [2,2], // 3-c
      [1,1], // 2-b
      [3,3], // 4-d
    ];
    return pattern.map(([idxA, idxB], i) => ({
      fencerA: membriA[idxA].name,
      fencerB: membriB[idxB].name,
      squadraA: nomeA,
      squadraB: nomeB,
      categoria,
      stoccate,
      stato: 'da disputare',
      note: '',
      id: `${categoria}_custom_${i}`
    }));
  }
  // fallback: diagonale per altri N
  const N = Math.min(membriA.length, membriB.length);
  return Array.from({length: N}).map((_, i) => ({
    fencerA: membriA[i].name,
    fencerB: membriB[i].name,
    squadraA: nomeA,
    squadraB: nomeB,
    categoria,
    stoccate,
    stato: 'da disputare',
    note: '',
    id: `${categoria}_custom_${i}`
  }));
}

